import { useHealthyAuth } from '@packages/healthy-auth';
import { tracking } from '@packages/tracking';
import { reporter } from '@packages/reporter';
import useLogoutCleanups from './useLogoutCleanups';

export default function useLogout() {
  const { logout: authLogout } = useHealthyAuth();
  const cleanupFunctions = useLogoutCleanups();

  const logoutCleanups = () => {
    cleanupFunctions.forEach((cleanupFn) => {
      try {
        cleanupFn();
      } catch (error) {
        reporter.error(error, { context: 'Failed to run cleanup function' });
      }
    });
  };

  const logout = () => {
    logoutCleanups();
    tracking.trackEvent({ eventName: 'logout' });
    authLogout();
  };

  return { logout, logoutCleanups };
}
